import { EquationType, OperatorType } from "../types/generalTypes";
import { ThemeType } from "../utils/storage";

export const clickTile = (number: number) => ({
  type: "CLICK_TILE",
  number,
});
export const clickOp = (op: OperatorType) => ({
  type: "CLICK_OPERATOR",
  op,
});
export const undo = () => ({
  type: "UNDO",
});
export const redo = () => ({
  type: "REDO",
});
export const reset = () => ({
  type: "RESET",
});
export const addSolution = (solution: EquationType) => ({
  type: "ADD_SOLUTION",
  solution,
});
export const loadSolutions = (solutions: EquationType[]) => ({
  type: "LOAD_SOLUTIONS",
  solutions,
});
export const newGame = () => ({
  type: "NEW_GAME",
});
export const loadGame = (target: number, grid: number[]) => ({
  type: "LOAD_GAME",
  target,
  grid,
});
export const toggleHowTo = (showHowTo: boolean) => ({
  type: "TOGGLE_HOW_TO",
  showHowTo,
});
export const toggleTitleScreen = () => ({
  type: "TOGGLE_TITLE_SCREEN",
});
export const screenResize = (width: number, height: number) => ({
  type: "SCREEN_RESIZE",
  width,
  height,
});
export const setEquationDiv = (div: HTMLElement) => ({
  type: "SET_EQUATION_DIV",
  div,
});
export const setGridSize = (cols: number, rows: number) =>
  rows === undefined
    ? {
        type: "SET_GRID_SIZE",
        size: cols,
      }
    : {
        type: "SET_GRID_SIZE",
        cols,
        rows,
      };
export const changeTab = (tabIndex: number) => ({
  type: "CHANGE_TAB",
  tabIndex,
});
export const reviewShown = (reviewShown: boolean) => ({
  type: "REVIEW_SHOWN",
  reviewShown,
});
// export const setNewGridMenu = (newGridMenu) => ({
//   type: "SET_NEW_GRID_MENU",
//   newGridMenu,
// });
export const setAppTheme = (theme: ThemeType) => ({
  type: "SET_APP_THEME",
  theme,
});
/*
export const refToGrid = (grid) => {
  console.log(grid);
  return {
    type: 'SET_GRID_DIMENSIONS',
    gridWidth: (grid !== null ? grid.offsetWidth : 0),
    gridHeight: window.innerHeight - 270,
  };
};
*/
